import PaymentFormItem from './payment-form-item';

export default class PaymentForm {
    public Address: string = '';
    public Method: string = '';
    public Items: Array<PaymentFormItem> = new Array<PaymentFormItem>();
}